<template>
    <Chart  @getData='getData'>
        <template #v>
            <div id="echart_four_two"></div>
        </template>
    </Chart>
</template>

<script>
import Chart from "../components/chart";
export default {
    name: "",
    data() {
        return {

        };
    },
    methods: {
        getData(plan,echarts,times) {
            let { axis,grid,title,legend } = plan

            let option = {
                color: '#4cbea4',
                title: {
                    text: "近八年地区生产总总值对比",
                    ...title,
                },
                legend: {
                    ...legend,
                    data: [],
                    right: "center",
                    top: 20,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid,
                xAxis: {
                    name: "年",
                    type: "category",
                    data: [],
                    ...axis,
                },
                yAxis: {
                    name: "",
                    ...axis,
                },
                series: [],
            };
            var url =
                this.urlobj.dx_jjfxty +
                `?tableName=rlt_40year_item_value&times=${times}&itemid=4`;
            this.$get(url).then((res) => {
                let data = res.rows[0].data;
                option.yAxis.name = data[0].dataArr[0].units
                let x = data[0].dataArr.map((item) => item.name);
                // option.legend.data = x;
                option.series = x.map((item) => {
                    return {
                        name: item,
                        data: [],
                        type: "line",
                        symbol: "none",
                        smooth:true,
                        areaStyle: {
                            color: option.color
                        }
                    };
                });
                let arr = [];
                data.forEach((item) => {
                    option.xAxis.data.push(item.time);
                    let obj = {};
                    item.dataArr.forEach((itemx) => {
                        obj[itemx.name] = itemx.value;
                    });
                    arr.push(obj);
                });
                option.series.forEach((item) => {
                    arr.forEach((itemx) => {
                        item.data.push(itemx[item.name]);
                    });
                });

                var myChart = echarts.init(
                    document.getElementById("echart_four_two")
                );

                myChart.setOption(option);

                
            });
        },
    },
    created() {

    },
    components: {
        Chart,
    },
};
</script>

<style lang="less" scoped>
#echart_four_two {
    height:250px;
    &::after {
        background-image: url("../../../assets/dongxiang/bight.png");
        position: absolute;
        content: "";
        display: block;
        right: -7px;
        bottom: -7px;
        width: 38px;
        height: 38px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
}
</style>
